<template>
  <div class="animated revealUp">
    <div class="white-wrapper" style="zoom: 0.9">
      <div class="section-title mb-4">{{ $t("3D Glass Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label :class="cogsPayload['cinema_id'] ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :options="Cinemas"
                v-model="selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder=""
                @select="onSelectCinema($event)"
                @remove="onRemoveCinema($event)"
              ></multiselect>
            </div>
          </div>
          <div class="col-sm-3 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="cogsPayload['fromDate']"
                  :disabled-dates="disabledDates"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="cogsPayload['fromDate'] ? 'active' : ''">
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="cogsPayload['toDate']"
                  :disabled-dates="disabledDates"
                ></Datepicker>
                <label :class="cogsPayload['toDate'] ? 'active' : ''">
                  {{ $t("todate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label :class="cogsPayload['rmc_id'] ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("category", 1) }}</label
              >
              <multiselect
                :options="rawMaterialCategories"
                v-model="selectedCategory"
                :searchable="true"
                label="rmc_category"
                track-by="rmc_id"
                placeholder=""
                @select="onSelectCategoey($event)"
                @remove="onRemoveCategory($event)"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-2 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label :class="cogsPayload['sm_id'] ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("store", 1) }}</label
              >
              <multiselect
                :options="storeList"
                v-model="selectedStore"
                :searchable="true"
                label="sm_store_name"
                track-by="sm_id"
                placeholder=""
                @select="onSelectLocation($event, 'select')"
                @remove="onSelectLocation($event, 'remove')"
              ></multiselect>
            </div>
          </div>
          <div class="col-sm-3 col-xl-2 align-self-center mb-2">
            <button @click="fetchFoodCostReport" class="btn btn-primary w-100">
              {{ $tc("getReport") }}
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div
            class="d-flex align-item-center justify-content-center"
            style="gap: 15px"
          >
            <b-form-input
              v-debounce:500="resetList"
              v-model="cogsPayload.searchValue"
              placeholder="Search..."
            />
          </div>
          <div class="d-flex"></div>
          <div class="d-flex align-items-center">
            <div
              v-if="getCogsRecords.length > 0"
              class="align-self-center mb-1 d-flex justify-content-end align-items-center"
            >
              <div>{{ $t("download") }} as:</div>
              <a
                target="_blank"
                download
                title="Download as PDF"
                @click="fetchFoodCostReport(`PDF`)"
              >
                <img
                  src="@/assets/img/icons/pdf-icon.svg"
                  height="25"
                  width="25"
                />
              </a>
              <a
                target="_blank"
                title="Download as Excel"
                @click="fetchFoodCostReport(`excel`)"
              >
                <img
                  class="mx-2"
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </a>
            </div>
            <div class="mx-2 text-left d-flex justify-content-end">
              <b-dropdown name="listview" id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  {{ $t("viewing") }}&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;{{ $t("of") }}&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  href="#"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="swc-report" style="overflow-x: scroll">
        <table class="swc-report-table" border="1" style="width: auto">
          <thead class="bg-lightgrey" style="white-space: nowrap">
            <tr>
              <th class="wd280">{{ $tc("rawmaterials") }}</th>
              <th>UOM</th>
              <th>{{ $t("rate") }}</th>
              <th>{{ $t("openingStock") }}</th>
              <th>{{ $t("opening") }} {{ $t("stock") }} {{ $t("value") }}</th>
              <th>{{ $t("purchase") }}</th>
              <th>{{ $t("purchase") }} {{ $t("value") }}</th>
              <th>{{ $t("purchase") }} {{ $t("return") }}</th>
              <th>{{ $t("purchase") }} {{ $t("return") }} {{ $t("value") }}</th>
              <th>{{ $t("tranferInFromUnit") }}</th>
              <th>{{ $t("tranferInFromUnit") }} {{ $t("value") }}</th>
              <th>{{ $t("transferOutUnit") }}</th>
              <th>{{ $t("transferOutUnit") }} {{ $t("value") }}</th>
              <th>{{ $t("property_in") }}</th>
              <th>{{ $t("property_in") }} {{ $t("value") }}</th>
              <th>{{ $t("property_out") }}</th>
              <th>{{ $t("property_out") }} {{ $t("value") }}</th>
              <th>{{ $t("consumption") }}</th>
              <th>{{ $t("consumption") }} {{ $t("value") }}</th>
              <th>{{ $t("system") }} {{ $t("stock") }}</th>
              <th>{{ $t("system") }} {{ $t("stock") }} {{ $t("value") }}</th>
              <th>{{ $t("wastage") }}</th>
              <th>{{ $t("wastage") }} {{ $t("value") }}</th>
              <th>{{ $t("variance") }}</th>
              <th>{{ $t("variance") }} {{ $t("value") }}</th>
              <th>{{ "Total Wtg./Var" }}</th>
            </tr>
          </thead>
          <tbody v-if="!getCogsGroupedRecords">
            <tr rowspan="13">
              <td colspan="13">
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody v-else class="sph-report">
            <template
              v-for="(
                RawMaterialCategory, RawMaterialCategoryIndex
              ) in Object.keys(getCogsGroupedRecords)"
            >
              <!-- <tr>
                <td
                  colspan="26"
                  class="font-weight-bold text-left concession_blue"
                  style="border-right-color: transparent"
                >
                  {{ RawMaterialCategory }}
                </td>
              </tr> -->
              <tr
                v-for="(
                  singleRawItem, singleRawItemKey
                ) in getCogsGroupedRecords[RawMaterialCategory]"
                :key="singleRawItemKey"
                class="text-right"
              >
                <td class="text-left">{{ singleRawItem.rm_name }}</td>
                <td class="text-left">{{ singleRawItem.uom_name }}</td>
                <td>{{ currFormat(singleRawItem.purchase_rate) }}</td>

                <td>
                  <div>
                    {{
                      parseFloat(singleRawItem.opening_stock || 0).toFixed(5)
                    }}
                  </div>
                </td>
                <td>
                  {{ currFormat(singleRawItem.opening_stock_value) }}
                </td>
                <td>
                  <div>
                    {{
                      parseFloat(singleRawItem.purchase_stock || 0).toFixed(5)
                    }}
                  </div>
                </td>
                <td>
                  {{ currFormat(singleRawItem.purchase_stock_value) }}
                </td>
                <td>
                  <div>
                    {{
                      parseFloat(singleRawItem.purchase_return || 0).toFixed(5)
                    }}
                  </div>
                </td>
                <td>
                  {{ currFormat(singleRawItem.purchase_return_value) }}
                </td>
                <td>
                  <div>
                    {{ parseFloat(singleRawItem.transfer_in || 0).toFixed(5) }}
                  </div>
                </td>
                <td>
                  {{ currFormat(singleRawItem.transfer_in_value) }}
                </td>

                <td>
                  <div>
                    {{ parseFloat(singleRawItem.transfer_out || 0).toFixed(5) }}
                  </div>
                </td>
                <td>
                  {{ currFormat(singleRawItem.transfer_out_value) }}
                </td>
                <td>
                  <div>
                    {{ parseFloat(singleRawItem.property_in || 0).toFixed(5) }}
                  </div>
                </td>
                <td>
                  {{ currFormat(singleRawItem.property_in_value) }}
                </td>
                <td>
                  <div>
                    {{ parseFloat(singleRawItem.property_out || 0).toFixed(5) }}
                  </div>
                </td>
                <td>
                  {{ currFormat(singleRawItem.property_out_value) }}
                </td>
                <td>
                  <div>
                    {{
                      parseFloat(singleRawItem.standard_consumed || 0).toFixed(
                        5
                      )
                    }}
                  </div>
                </td>
                <td>
                  <div>
                    {{
                      parseFloat(singleRawItem.standard_consumed_value).toFixed(
                        5
                      )
                    }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ parseFloat(singleRawItem.system_stock || 0).toFixed(5) }}
                  </div>
                </td>
                <td>
                  {{
                    currFormat(
                      singleRawItem.system_stock_value
                    )
                  }}
                </td>
                <td>
                  <div>
                    {{ parseFloat(singleRawItem.wastage || 0).toFixed(5) }}
                  </div>
                </td>
                <td>
                  {{ currFormat(singleRawItem.wastage_value) }}
                </td>

                <td>
                  <div>
                    {{ parseFloat(singleRawItem.variance || 0).toFixed(5) }}
                  </div>
                </td>
                <td>
                  {{ currFormat(singleRawItem.variance_value) }}
                </td>
                <td>
                  <div>
                    {{
                      parseFloat(
                        singleRawItem.wastage +
                          getOnlyPositiveNumber(singleRawItem.variance)
                      ).toFixed(5)
                    }}
                  </div>
                </td>
              </tr>
              <!-- <tr class="font-weight-bold" style="background-color: #e8e8e8">
                <td class="text-left">Total</td>
                <td class="text-right">-</td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate }) => {
                        return acc + purchase_rate;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { opening_stock }) => {
                        return acc + opening_stock;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate, opening_stock_value }) => {
                        return acc + opening_stock_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_stock }) => {
                        return acc + purchase_stock;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate, purchase_stock_value }) => {
                        return acc + purchase_stock_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_return }) => {
                        return acc + purchase_return;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate, purchase_return_value }) => {
                        return acc + purchase_return_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { transfer_in }) => {
                        return acc + transfer_in;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate, transfer_in_value }) => {
                        return acc + transfer_in_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { transfer_out }) => {
                        return acc + transfer_out;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate, transfer_out_value }) => {
                        return acc + transfer_out_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { property_in }) => {
                        return acc + property_in;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate, property_in_value }) => {
                        return acc + property_in_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { property_out }) => {
                        return acc + property_out;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate, property_out_value }) => {
                        return acc + property_out_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { standard_consumed }) => {
                        return acc + standard_consumed;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { standard_consumed_value, purchase_rate }) => {
                        return acc + standard_consumed_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { system_stock }) => {
                        return acc + system_stock;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate, system_stock_value }) => {
                        return acc + system_stock_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { wastage }) => {
                        return acc + wastage;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate, wastage_value }) => {
                        return acc + wastage_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { variance }) => {
                        return acc + variance;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { purchase_rate, variance_value }) => {
                        return acc + variance_value;
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
                <td class="text-right">
                  {{
                    getCogsGroupedRecords[RawMaterialCategory].reduce(
                      (acc, { wastage, variance }) => {
                        return acc + wastage + getOnlyPositiveNumber(variance);
                      },
                      0
                    ).toFixed(4)
                  }}
                </td>
              </tr> -->
            </template>
            <tr class="bg-lightgrey">
              <td class="text-left font-weight-bold">Grand Total</td>
              <td class="text-right">-</td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate }) => total + purchase_rate,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { opening_stock }) => total + opening_stock,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate, opening_stock_value }) =>
                            total + opening_stock_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_stock }) => total + purchase_stock,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate, purchase_stock_value }) =>
                            total + purchase_stock_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_return }) =>
                            total + purchase_return,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate, purchase_return_value }) =>
                            total + purchase_return_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { transfer_in }) => total + transfer_in,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate, transfer_in_value }) =>
                            total + transfer_in_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { transfer_out }) => total + transfer_out,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate, transfer_out_value }) =>
                            total + transfer_out_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { property_in }) => total + property_in,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate, property_in_value }) =>
                            total + property_in_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { property_out }) => total + property_out,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate, property_out_value }) =>
                            total + property_out_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { standard_consumed }) =>
                            total + standard_consumed,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { standard_consumed_value, purchase_rate }) =>
                            total + standard_consumed_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { system_stock }) => total + system_stock,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate, system_stock_value }) =>
                            total + system_stock_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { wastage }) => total + wastage,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate, wastage_value }) =>
                            total + wastage_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { variance }) => total + variance,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { purchase_rate, variance_value }) =>
                            total + variance_value,
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
              <td class="text-right">
                {{
                  Object.values(getCogsGroupedRecords)
                    .reduce(
                      (acc, category) =>
                        acc +
                        category.reduce(
                          (total, { wastage, variance }) =>
                            total + wastage + getOnlyPositiveNumber(variance),
                          0
                        ),
                      0
                    )
                    .toFixed(4)
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
  <script>
import DatePicker from "vue2-datepicker";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import PosFnbService from "@/services/PosFnbService";
import moment from "moment";

export default {
  components: { DatePicker, NoRecords },
  data() {
    return {
      showRate: false,
      Cinemas: [],
      isRoleID: false,
      CinemasCopy: [],
      searchCinema: "",
      rawMaterialCategories: [],
      rawMaterialCategoriesCopy: [],
      searchRawMaterial: "",
      storeList: [],
      selectedStore: null,
      cogsPayload: {
        fromDate: new Date(),
        toDate: new Date(),
        cinema_id: null,
        rmc_id: null,
        searchValue: "",
        sm_id: null,
      },
      disabledDates: {
        from: new Date(),
      },
      selectedCinema: "",
      slectedCinemaAddress: "",
      selectedCategory: "",
      getCogsRecords: [],
      getCogsGroupedRecords: null,
      getCogsPDF: null,
      getCogsExcel: null,

      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "50", id: 1 },
        { name: "100", id: 2 },
        { name: "200", id: 3 },
        { name: "300", id: 4 },
      ],

      debounce: null,
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  computed: {},
  mounted() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    this.fetchRawMaterialCategory();
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
  },
  watch: {},
  methods: {
    onChangeDate(e, type) {
      // console.log("onChangeDate", type);
      if (type == "from") {
        this.cogsPayload.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    onSelectLocation(store, type) {
      if (type == "remove") {
        this.selectedStore = null;
        this.cogsPayload["sm_id"] = null;
      } else {
        this.selectedStore = store;
        this.cogsPayload["sm_id"] = store["sm_id"];
      }
    },
    getStockManagementData: function (cinema_id) {
      let payload = {
        cinema_id: cinema_id || this.cogsPayload["cinema_id"],
      };
      PosFnbService.GetStoreManagementDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.Records && data.Records.length) {
            this.storeList = response.data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    getOnlyPositiveNumber(number) {
      let returnNumber = 0;
      if (!number || isNaN(number)) {
        returnNumber = 0;
      } else if (number > 0) {
        returnNumber = 0;
      } else {
        returnNumber = Math.abs(number);
      }
      return +parseFloat(returnNumber);
    },
    excelDownload() {},
    onSelectCinema(cinema) {
      this.cogsPayload["cinema_id"] = cinema["cine_id"];
      this.selectedCinema = cinema;
      this.slectedCinemaAddress = cinema;
      this.getStockManagementData(cinema["cine_id"]);
    },
    onRemoveCinema() {
      this.cogsPayload["cinema_id"] = null;
      this.selectedCinema = "";
    },
    onSelectCategoey(category) {
      this.cogsPayload["rmc_id"] = category["rmc_id"];
      this.selectedCategory = category;
    },
    onRemoveCategory(cinema) {
      this.cogsPayload["rmc_id"] = null;
      this.selectedCategory = "";
    },
    fetchRawMaterialCategory() {
      let body = {
        tableName: "ms_raw_material_category",
        rmc_is_active: "Y",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.rawMaterialCategories = data.Records;
            console.log(
              "this.rawMaterialCategories  :>> ",
              this.rawMaterialCategories
            );
          } else Vue.toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch((error) => {
          Vue.toasted.show(
            "Catch Error on MasterStore fetchCinemasList",
            error
          );
        });
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;

          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(null, {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    fetchFoodCostReport(action = null) {
      if (
        !this.cogsPayload["fromDate"] ||
        !moment(this.cogsPayload["fromDate"]).isValid()
      ) {
        return this.$toasted.show("Please Enter a Valid From Date");
      } else if (
        !this.cogsPayload["toDate"] ||
        !moment(this.cogsPayload["toDate"]).isValid()
      ) {
        return this.$toasted.show("Please Enter a Valid To Date");
      } else if (
        moment(this.cogsPayload["toDate"]).isBefore(
          moment(this.cogsPayload["fromDate"])
        )
      ) {
        return this.$toasted.show("Please Enter a Valid Date Range");
      } else if (!this.cogsPayload["cinema_id"]) {
        return this.$toasted.show("Please Select Cinema");
      } else {
        let loader = this.$loading.show();
        let payload = {
          fromDate: moment(this.cogsPayload["fromDate"]).format("YYYY-MM-DD"),
          toDate: moment(this.cogsPayload["toDate"]).format("YYYY-MM-DD"),
          cinema_id: this.cogsPayload["cinema_id"] || null,
          category_id: this.cogsPayload["rmc_id"] || null,
          searchValue: this.cogsPayload["searchValue"] || null,
          cinema_name: this.selectedCinema.cine_name,
          orderBy: this.orderBy,
          columnName: this.columnName,
          currentPage: this.currentPage,
          limit: null,
          isExcelDownload: action == "excel" ? "Y" : "N",
          isPdfDownload: action == "PDF" ? "Y" : "N",
          isStoreWise: "N",
          sm_id: this.cogsPayload["sm_id"] || null,
          cinema_address: this.slectedCinemaAddress.cine_address,
        };
        ReportsService.getConcession3DGlassReport(payload)
          .then((response) => {
            const { data } = response;

            if (
              data &&
              data.hasOwnProperty("totalCount") &&
              this.currentPage == 1
            ) {
              this.rows = data.totalCount;
              if (data.totalCount >= 10) {
                this.rows = data.totalCount;
              } else {
                this.rows = data.totalCount;
                this.selectedvalue = data.totalCount;
              }
            }
            if (
              data &&
              data.status &&
              data.hasOwnProperty("excelPath") &&
              data.excelPath &&
              action == "excel"
            ) {
              window.open(data.excelPath, "_blank");
            } else if (
              data &&
              data.status &&
              data.hasOwnProperty("pdfPath") &&
              data.pdfPath &&
              action == "PDF"
            ) {
              window.open(data.pdfPath, "_blank");
            } else if (
              data &&
              data.status &&
              data.hasOwnProperty("groupedData") &&
              Object.keys(data.groupedData).length > 0
            ) {
              this.getCogsRecords = data.Records || [];
              this.getCogsGroupedRecords = data.groupedData || null;
              //console.log("getCogsGroupedRecords", this.getCogsGroupedRecords)
            } else {
              this.getCogsRecords = [];
              this.getCogsGroupedRecords = null;

              this.$toasted.show(data.message || "No Records Found");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            this.getCogsRecords = [];
            this.getCogsGroupedRecords = null;
            this.$toasted.show("Error");
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.fetchFoodCostReport();
      } else {
        this.currentPage = event;
        this.fetchFoodCostReport();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.resetList();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.resetList();
      }
    },
    resetList() {
      this.isSort = false;
      this.isAscending = true;
      this.isAscending = true;
      this.orderby = "";
      this.columnName = "";
      this.currentPage = 1;
      this.fetchFoodCostReport();
    },
  },
};
</script>
  
  <style scoped>
.sph-report th,
td {
  height: 30px;
}

.sph-report tbody tr,
td {
  white-space: normal !important;
}
.text_right {
  text-align: right;
}
.wd280 {
  min-width: 280px;
}
.concession_blue {
  background-color: #c5d6f0 !important;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/getConcession3DGlassReport.vue